<template>
  <div class="titleToolbar" @keydown.stop>
    <div class="left-grid">
      <el-tooltip
        effect="dark"
        content="快捷菜单"
        placement="bottom"
        :open-delay="1000"
      >
        <div class="hamburger-menu cursor" @click="openQuickManu">
          <div class="menu-icon"></div>
        </div>
      </el-tooltip>
      <a class="logo cursor" target="_blank" href="/templates">
        <img src="../../../../static/svg/laihua-logo-dark.png" alt="logo" />
      </a>
      <input
        class="title"
        v-model="videoName"
        type="text"
        maxlength="32"
        @focus="editVideoNameFocus()"
        @blur="editVideoNameBlur()"
        @keydown.enter="editVideoName()"
      />
    </div>

    <div
      :style="{ color: '#474261', 'font-weight': 'bold', 'font-size': '14px' }"
    >
      添加字幕
    </div>

    <div class="right-grid">
      <div class="vipUpgrade cursor" v-if="UserLevel == 0">
        <div class="button-layout">
          <div class="icon"></div>
          <span>会员升级</span>
        </div>

        <div class="vip-drop">
          <VipDrop></VipDrop>
        </div>
      </div>

      <div class="complete-button cursor" @click="showExport">导出</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VipDrop from "../subtitleVipDrop";
import { modifyVideoTitle, getUserVideoInfo } from "../subtitleApi";
export default {
  name: "videoTitleToolbar",
  data() {
    return {
      // videoName: ""
    };
  },
  props: {},
  components: { VipDrop },
  methods: {
    editVideoNameFocus() {
      this.backTitle = this.subtitleObj.title;
    },
    editVideoNameBlur() {
      if (!this.videoName) {
        this.videoName = this.backTitle;
      } else {
        this.changedvideoName();
      }
    },
    async changedvideoName() {
      let id = this.subtitleObj.id;
      let res = await modifyVideoTitle(id, this.videoName);
      if (res) {
        this.subtitleObj.title = this.videoName;
      }
      this.$message({
        showClose: false,
        message: res ? "修改成功！" : "修改失败！",
        type: res ? "success" : "error",
        center: true,
      });
    },
    openQuickManu() {
      //this.$emit("openQuickMenu");
      this.$bus.emit("showQuickMenu");
    },
    showExport() {
      this.$store.commit("subtitle/setSubIndex", -1); //取消字幕选中状态
      this.$store.commit("subtitleExport/showExport", true);
    },
  },
  watch: {},
  computed: {
    ...mapGetters({
      subtitleObj: "subtitle/subtitleObj",
      subtitleTitle: "subtitle/title",
      UserLevel: "UserLevel",
    }),
    videoName: {
      get() {
        return this.subtitleObj.title;
      },
      set(val) {
        this.$store.commit("subtitle/setTitle", val);
      },
    },
  },
};
</script>

<style scoped lang='scss'>
@import "./commonStyle.scss";

.left-grid {
  flex-grow: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 1px;
}
.right-grid {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/titleToolbar/videoTitleToolbar.vue